module.exports = __webpack_public_path__ + "static/media/harrypotter.43b1a27a.jpeg";